import script from "./NewPasswordOverlays.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPasswordOverlays.vue?vue&type=script&setup=true&lang=ts"

import "./NewPasswordOverlays.vue?vue&type=style&index=0&id=0fd7dee5&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd7dee5"]])

export default __exports__